// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"7406":"route-articles","9324":"route-marketplace","18597":"theme-picker","47960":"route-account","49218":"route-investors","66942":"route-home","83179":"route-create","88103":"route-edit"}[chunkId] || chunkId) + "." + __webpack_require__.h() + ".css";
};